<section class="trending" aria-labelledby="communityTrendingTitle">
  <h2 class="trending__title" id="communityTrendingTitle">What's trending</h2>

  <ol class="trending__list">
    @if (feed === undefined) {
      @for (skeleton of skeletons; track skeleton) {
        <li class="trending__item" aria-hidden="true">
          <span class="trending__skeleton trending__skeleton--title"></span>
          <span class="trending__skeleton"></span>
        </li>
      }
    } @else {
      @for (item of visibleItems; track item.id; let i = $index) {
        <li class="trending__item trending__item--ranked">
          <span class="trending__rank" aria-hidden="true">{{ rank(i) }}</span>
          <div class="trending__item-content">
            @if (title(item)) {
              <h3 class="trending__item-heading">
                @if (route(item); as r) {
                  <a class="trending__item-title" [uiSref]="r.state" [uiParams]="r.params" [innerHTML]="titleHtml(item)"></a>
                } @else {
                  <span class="trending__item-title" [innerHTML]="titleHtml(item)"></span>
                }
              </h3>
            }
            @if (item.type === 'status' && item.attached_url) {
              <ut-status-attachment class="trending__thumbnail" [status]="item"></ut-status-attachment>
            }
            <div class="trending__item-details">
              @if (item.type !== 'project' && item.user) {
                <ut-avatar-badges class="trending__avatar" [user]="item.user" aria-hidden="true"></ut-avatar-badges>
              }
              <div class="trending__item-text">
                @if (item.user) {
                  <a class="trending__item-author" uiSref="profile.about" [uiParams]="{ profileId: item.user.slug }">{{ item.user.name }}</a>
                }
                <span class="trending__item-meta">
                  {{ typeLabel(item) }} <span aria-hidden="true">&middot;</span> {{ item.published_at | relativeDate }}
                  @if (item.type !== 'project') {
                    <span class="trending__stat">
                      <span class="material-icons" aria-hidden="true">favorite_border</span>
                      <span class="sr-only">Likes:&ngsp;</span>{{ likeCount(item) | utNumToK }}
                    </span>
                    <span class="trending__stat">
                      <span class="material-icons" aria-hidden="true">chat_bubble_outline</span>
                      <span class="sr-only">Comments:&ngsp;</span>{{ commentCount(item) | utNumToK }}
                    </span>
                  }
                </span>
              </div>
            </div>
          </div>
        </li>
      }
    }
  </ol>

  @if (feed && canExpand) {
    <button type="button" class="ut-btn ut-btn--secondary ut-btn--sm trending__toggle" [attr.aria-expanded]="expanded()" (click)="expanded.set(!expanded())">
      {{ expanded() ? 'Show less' : 'Show more' }}
    </button>
  }
</section>
